
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import Beleg from '@/types/Beleg';
    import Belegposition from '@/types/Belegposition';
    import DialogDruckOk from '@/components/Impfverwaltung/Rechnung/DialogDruckOk.vue';
    import Patient from '@/types/Patient';
    import { Tarifart } from '@/types/Tarifart';
    import { NeueRechnungPayload, UpdateRechnungPayload } from '@/store/patientrechnungen';
    import { warningSwal } from '@/helper/swals';
    import Warteliste from '@/types/Warteliste';
    import { ListItems, VForm, VTextField } from '@/types/Components';
    import { DataTableHeaders, MutableDataTableHeaders } from '@/types';
    import { SystemEinstellung, SystemEinstellungKey } from '@/types/Einstellung';
    import api from '@/services/Api';
    import axios, {AxiosResponse, CancelTokenSource} from 'axios';
    import {PatientSearchItem} from '@/components/Impfverwaltung/Patient/PatientSearch.vue';
    import _ from 'lodash';
    import moment from 'moment';
    import DatePickerInput from '@/components/DatePickerInput.vue';

    @Component({
        components: {
            DialogDruckOk,
            DatePickerInput,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('patient', [
                'patientData',
                'loadedPatientData',
                'beleg',
                'belegPositionen',
                'belegPatienten',
                'druckvorgang',
                'abbrechungsvorgang',
                'dialogs',
                'loadRechnung',
                'abbrechungsvorgangAlle',
                'zahlendePatienten',
            ]),
            ...mapState('zahlungsarten', ['arten']),
            ...mapState('zahlungsarten', { zahlungsartenLoaders: 'loaders' }),
            ...mapGetters('authentication', ['impfstelleDetail', 'getSystemEinstellung']),
            ...mapGetters('patient', ['getOffeneImpfungen']),
            ...mapGetters('leistungen', ['getVerwaltungsabgabe']),
            ...mapState('warteliste', ['warteliste']),
        },
        methods: {
            ...mapActions('patient', ['neueRechnung', 'updateAbrechnung', 'rechnungAbbrechen', 'resetRechnungsdruck']),
            ...mapActions('zahlungsarten', ['loadZahlungsarten']),
            ...mapMutations('patient', ['setDialogRechnung', 'setDialogSammelrechnung']),
            ...mapActions('patient', ['loadPatient', 'getLoadedPatient']),
        },
    })
    export default class Sammelrechnung extends Vue {
        @Prop() visible!: boolean;

        public $refs!: {
            form: VForm;
            diagnose: VTextField;
        };

        public hcw_einschliessen = 'j';

        public beleg!: Beleg;
        public patientData!: Patient | any;
        public loadedPatientData!: Patient | any;
        public belegPositionen!: Belegposition[];
        public belegPatienten!: Patient[];
        //public zahlendePatienten!: Warteliste[];
        //public warteliste!: Warteliste[];
        public loadZahlungsarten!: () => void;
        public rechnungAbbrechen!: () => void;
        public neueRechnung!: (payload: NeueRechnungPayload) => void;
        public updateAbrechnung!: (payload: UpdateRechnungPayload) => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;
        public resetRechnungsdruck!: () => void;
        public setDialogSammelrechnung!: (visible: boolean) => void;
        public loadPatient!: (payload: { patnr: number | null }) => Promise<void>;
        public getLoadedPatient!: (payload: { patnr: number | any }) => Promise<void>;

        public patienten: Patient[] = [];
        public selectedPatienten: Warteliste[] = [];
        public items: Belegposition[] = [];

        public search = '';
        public validSearch = true;
        public loading = false;
        public patientenSearchItems: PatientSearchItem[] = [];
        public searchApiCall: _.DebouncedFunc<(query: string) => void> | null = null;
        public source: CancelTokenSource | null = null;
        public patientSearch: PatientSearchItem | string | any = '';

        public readonly tarife: ListItems<Tarifart> = [
            { value: Tarifart.Normal, text: 'Normaltarif' },
            { value: Tarifart.Individuell, text: 'Individualtarif' },
            { value: Tarifart.KeineVerrechnung, text: 'keine Verrechnung' },
            { value: Tarifart.Spaeter, text: 'später verrechnen' },
            { value: Tarifart.Rabatt5, text: '5% Rabatt' },
            { value: Tarifart.Rabatt10, text: '10% Rabatt' },
            { value: Tarifart.Rabatt15, text: '15% Rabatt' },
            { value: Tarifart.Rabatt20, text: '20% Rabatt' },
            { value: Tarifart.Rabatt30, text: '30% Rabatt' },
        ];

        public currentBeleg = new Beleg();
        public rechnungsempfaenger = new Patient();
        public erstordination = true;

        public filter: any = {
            student: 'n',
            bis: moment().format('YYYY-MM-DD'),
        };

        public get headers(): DataTableHeaders<Warteliste, 'patient' | 'action'> {
            const headers: MutableDataTableHeaders<Warteliste, 'patient' | 'action'> = this.showSelect
                ? [{ value: 'action', text: '', sortable: false, width: 40 }]
                : [];

            headers.push({ value: 'patient', text: 'Rechnung wird für folgende Patienten erstellt:', sortable: false });

            return headers;
        }

        public get showSelect(): boolean {
            //return !this.onlySinglePatient && !this.hasPositionen;
            return !this.hasPositionen;
        }

        public get hasPositionen(): boolean {
            return this.belegPositionen.length > 0;
        }

        public get onlySinglePatient(): boolean {
            //return this.patienten.length === 1;
            return false;
        }

        /*        public get selectedZahlendePatienten(): boolean {
            return this.zahlendePatienten.length > 0;
        }*/

        public get tempRechnungsEmpfaenger(): Patient | undefined {
            const rechnungsEmpfaenger = this.rechnungsempfaenger;
            return rechnungsEmpfaenger;
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
                if (this.$refs.diagnose) {
                    this.$refs.diagnose.resetValidation();
                }

                this.hcw_einschliessen = 'j';
                this.filter.bis = moment().format('YYYY-MM-DD');

                this.currentBeleg = new Beleg();
                this.items = [];
                this.selectedPatienten = [];
                this.erstordination = true;
                this.searchApiCall = null;
                this.selectedPatienten = [];
                this.patienten = [];
                this.search = '';
                this.patientSearch = '';
                this.filter.student = 'n';

                this.loadZahlungsarten();

                api.post('ivs/rechnung/getsammelrechnungpatienten', {filter: this.filter})
                    .then((response: AxiosResponse) => {
                        this.patienten = response.data.body;
                    })
                    .catch(console.error);

                /*const isSelected = this.selectedZahlendePatienten;

                this.patienten = isSelected
                    ? [...this.zahlendePatienten]
                    : [...this.warteliste];

                if (this.onlySinglePatient) {
                    this.selectedPatienten = [...this.patienten];
                }*/
            }
        }

        public onChangeFilter(): void {
            api.post('ivs/rechnung/getsammelrechnungpatienten', {filter: this.filter})
                .then((response: AxiosResponse) => {
                    this.patienten = response.data.body;
                })
                .catch(console.error);
        }

        @Watch('belegPositionen')
        public onChangeBelegpositionen(positionen: Belegposition[]): void {
            if (positionen.length === 0) {
                return;
            }

            const zahlungsart = this.currentBeleg.zahlungsart;
            const diagnose = this.currentBeleg.diagnose;
            const adresszeile1 = this.currentBeleg.adresszeile1;
            const adresszeile2 = this.currentBeleg.adresszeile2;
            const adresszeile3 = this.currentBeleg.adresszeile3;
            const adresszeile4 = this.currentBeleg.adresszeile4;

            this.currentBeleg = new Beleg(this.beleg);
            this.currentBeleg.zahlungsart = zahlungsart;
            this.currentBeleg.diagnose = diagnose;
            this.currentBeleg.adresszeile1 = adresszeile1;
            this.currentBeleg.adresszeile2 = adresszeile2;
            this.currentBeleg.adresszeile3 = adresszeile3;
            this.currentBeleg.adresszeile4 = adresszeile4;

            this.items = positionen;
            this.selectedPatienten = [];
        }

        public onClickPatientenadresse(): void {
            if (this.hasPositionen && this.rechnungsempfaenger.patnr) {
                Object.assign(this.currentBeleg, {
                    name: this.rechnungsempfaenger.name,
                    adresszeile1: this.rechnungsempfaenger.name,
                    adresszeile2: this.rechnungsempfaenger.strasse ?? '',
                    adresszeile3: [this.rechnungsempfaenger.plz, this.rechnungsempfaenger.ort]
                        .filter((str) => str)
                        .join(' '),
                    adresszeile4: this.rechnungsempfaenger.land_bezeichnung ?? '',
                });
            }
        }

        public onClickRechnungsadresse(): void {
            if (this.hasPositionen && this.rechnungsempfaenger.patnr) {
                const zeilen = [
                    this.rechnungsempfaenger.rech_adrzeile1,
                    this.rechnungsempfaenger.rech_adrzeile2,
                    this.rechnungsempfaenger.rech_adrzeile3,
                ];

                const plzOrt = [
                    this.rechnungsempfaenger.rech_plz,
                    this.rechnungsempfaenger.rech_ort,
                ];

                Object.assign(this.currentBeleg, {
                    name: this.rechnungsempfaenger.name,
                    adresszeile1: zeilen.filter((str) => str).join('\n'),
                    adresszeile2: this.rechnungsempfaenger.rech_strasse ?? '',
                    adresszeile3: plzOrt.filter((str) => str).join(' '),
                    adresszeile4: this.rechnungsempfaenger.rech_land_bezeichnung ?? '',
                });
            }
        }

        public calcPreis(item: Belegposition): number {
            if (item.tarifart === Tarifart.Individuell) {
                item.verkaufspreis_brutto = item.temp_verkaufspreis || 0;
            } else {
                if (item.isImpfung) {
                    if (!this.getSystemEinstellung('muw').isEnabled()) {
                        item.verkaufspreis_brutto = item.impfstoff_verkaufspreis ?? 0;
                    }
                } else if (item.isLeistung) {
                    if (!this.getSystemEinstellung('muw').isEnabled()) {
                        item.verkaufspreis_brutto = item.leistung_preis ?? 0;
                    }
                } else if (item.isUntersuchung) {
                    if (!this.getSystemEinstellung('muw').isEnabled()) {
                        item.verkaufspreis_brutto = item.untersuchung_preis ?? 0;
                    }
                } else {
                    item.verkaufspreis_brutto = 0;
                }
            }

            const rabatt = ((): number => {
                switch (item.tarifart) {
                    case Tarifart.Rabatt5:
                        return 0.95;
                    case Tarifart.Rabatt10:
                        return 0.9;
                    case Tarifart.Rabatt15:
                        return 0.85;
                    case Tarifart.Rabatt20:
                        return 0.8;
                    case Tarifart.Rabatt30:
                        return 0.7;
                    case Tarifart.Spaeter:
                        return 0;
                    case Tarifart.KeineVerrechnung:
                        return 0;
                    default:
                        return 1;
                }
            })();

            //const round = (betrag: number): number => Math.round(betrag * 100) / 100;
            const round = (betrag: number): number => Number(Number.parseFloat(String(betrag)).toFixed(2));

            item.anzahl = item.anzahl ?? 1;
            if (item.verkaufspreis_brutto) {
                item.betrag_brutto = round(item.verkaufspreis_brutto * item.anzahl * rabatt);
            } else {
                item.betrag_brutto = 0;
            }
            item.steuersatz = item.steuersatz ?? 0;
            if (item.verkaufspreis_brutto) {
                item.verkaufspreis = round((item.verkaufspreis_brutto / (1 + (item.steuersatz / 100))) * rabatt);
            } else {
                item.verkaufspreis = 0;
            }
            item.betrag = item.verkaufspreis * item.anzahl;
            item.steuer = item.betrag_brutto - item.betrag;

            return item.betrag_brutto;
        }

        public sumBetrag(sum: number, pos: Belegposition): number {
            return sum += this.calcPreis(pos);
        }

        public sumBetragBrutto(sum: number, pos: Belegposition): number {
            return sum += pos.betrag_brutto ?? 0;
        }

        public sumBetragNetto(sum: number, pos: Belegposition): number {
            return sum += pos.betrag ?? 0;
        }

        public getSum(): number {
            const sum = this.items.reduce(this.sumBetrag, 0);
            this.currentBeleg.gesamtbetrag = sum;
            return sum;
        }

        public calcBruttoNetto(mehrwertsteuer: number): { brutto: number; netto: number; mwst: number } {
            if (mehrwertsteuer === 0) {
                const brutto = this.items
                    .filter(({ steuersatz }) => ![10, 20].includes(steuersatz ?? 0))
                    .reduce(this.sumBetragBrutto, 0);

                return {
                    brutto,
                    netto: brutto,
                    mwst: 0,
                };
            }

            const brutto = this.items
                .filter(({ steuersatz }) => steuersatz === mehrwertsteuer)
                .reduce(this.sumBetragBrutto, 0);

            const netto = this.items
                .filter(({ steuersatz }) => steuersatz === mehrwertsteuer)
                .reduce(this.sumBetragNetto, 0);

            return {
                brutto,
                netto,
                mwst: brutto - netto,
            };
        }

        public onClickCreate(): void {
            if (!this.currentBeleg.patnr) {
                warningSwal('Warnung', 'Bitte wählen Sie einen Rechnungsempfänger aus.');
                return;
            }

            if (!this.hasPositionen && this.selectedPatienten.length > 0) {
                this.neueRechnung({
                    patienten: this.selectedPatienten.map(({ patnr }) => patnr as number),
                    erstordination: this.erstordination,
                    rechnungsempfaenger: this.tempRechnungsEmpfaenger?.patnr as number,
                    hcw_einschliessen: this.hcw_einschliessen,
                    sammelrechnung: true,
                    bis: this.filter.bis
                });
            }
        }

        public onClickCancel(): void {
            if (this.hasPositionen) {
                this.rechnungAbbrechen();
            } else {
                this.setDialogSammelrechnung(false);
            }
        }

        public onClickPrint(): void {
            if (!this.$refs.form.validate() || !this.$refs.diagnose.validate() || !this.hasPositionen) {
                return;
            }

            if (!this.currentBeleg.patnr) {
                warningSwal('Warnung', 'Bitte wählen Sie einen Rechnungsempfänger aus.');
                return;
            }

            this.updateAbrechnung({
                beleg: this.currentBeleg,
                belegpositionen: this.items,
                count: this.getSystemEinstellung('rechnungsdruck_doppelt').isEnabled() ? 2 : 1,
                sammelrechnung: true
            });
        }

        public onClickCancelDruckOk(): void {
            this.resetRechnungsdruck();
        }

        public querySelections(query: string): void {
            this.validSearch = query.trim().length >= 3 && query[0] !== ' ';

            if (!this.validSearch) {
                this.items = [];
                return;
            }

            this.loading = true;

            if (!this.searchApiCall) {
                this.searchApiCall = _.debounce((query: string) => {
                    if (this.source) {
                        this.source.cancel('cancel ivs/patienten/search');
                    }

                    this.source = axios.CancelToken.source();

                    api.post('ivs/patienten/search', { query }, { cancelToken: this.source.token })
                        .then((res: AxiosResponse) => {
                            const items: PatientSearchItem[] = [];

                            res.data.body
                                .map((data: Partial<Patient>) => new Patient(data))
                                .forEach((patient: Patient, idx: number) => {
                                    items.push({
                                        name: patient.nachname + ' ' + patient.vorname,
                                        id: patient.patnr as number,
                                        geburtsDatum: patient.geburtsdatum ?? '',
                                        adresse: patient.Adresse,
                                    });

                                    if (idx !== res.data.body.length - 1) {
                                        items.push({ divider: true });
                                    }
                                });

                            this.patientenSearchItems = items;
                            this.loading = false;
                        })
                        .catch(console.error)
                        .finally(() => {
                            this.source = null;
                        });
                }, 500);
            }
            this.searchApiCall(query);
        }

        public onClickPatient(patnr: number): void {
            this.$emit('close');
            this.$router.push('/');
            //this.loadPatient({ patnr });
        }

        @Watch('patientSearch')
        public onChangeBelegPatient() {
            this.getLoadedPatient({ patnr: String(this.patientSearch?.id) });
        }

        @Watch('search', { immediate: true })
        public onChangeSearch(search: string): void {
            if (search) {
                this.querySelections(search);
            }
        }

        @Watch('loadedPatientData')
        public onChangeLoadedPatientData(): void {
            this.rechnungsempfaenger = this.loadedPatientData;

            this.currentBeleg.adresszeile1 = this.rechnungsempfaenger.name;
            this.currentBeleg.patnr = this.rechnungsempfaenger.patnr;
            this.currentBeleg.adresszeile2 = this.rechnungsempfaenger.strasse ?? '';
            this.currentBeleg.adresszeile3 = [this.rechnungsempfaenger.plz, this.rechnungsempfaenger.ort]
                .filter((str) => str)
                .join(' ');
            this.currentBeleg.adresszeile4 = this.rechnungsempfaenger.land_bezeichnung ?? '';
        }
    }
